import {isObject, copy} from 'angular';

export default function ($http) {
    return function (model) {
        model = copy(model);

        model.previousKeeper = cleanPerson(model.previousKeeper);
        model.mostRecentKeeper = cleanPerson(model.mostRecentKeeper);
        model.vehiclePurchasedBy = cleanPerson(model.vehiclePurchasedBy);
        return $http.post('api/enquiries/manual', model);
    };
}

function cleanPerson(person) {
    let isValid = false;

    if (isObject(person)) {
        isValid = Object.keys(person)
                        .every(key => person[key] !== null && person[key] !== undefined);
    }

    if (!isValid) {
        return null;
    }

    return person;
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/enquiries/createEnquiry.js